function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Fragment } from 'react';
import { withTheme } from 'styled-components';
import { Heart } from '@finect/tabular-icons/heart';
import { Share2 } from '@finect/tabular-icons/share2';
import { getProductPath, getProductDisplayName, getProductManager, getProductTypesByCategory } from '@finect/front-resources/Products';
import { getSuperPartnerBaseURL } from '@finect/front-utils/env';
import { Flex } from '@finect/tabular-core/Flex';
import { AppLink } from '@finect/tabular-core/AppLink';
import { isObject } from '@finect/front-utils/isObject';
import { Rating } from '../../Rating';
import { getTableCells } from '../ProductsTable/utils';
import { meta } from '../ProductsTable/entities/utils';
import { Share } from '../../Share';
import { fieldsByProductType } from '../fieldsByProductType';
import { PillModal } from '../../Pills';
import { Inner, HeaderBlockTop, HeaderActions, HeartAction, MainBlock, FeaturedFieldBlock, FeaturedFieldBlock2 } from './partials';
import { FieldsBlock } from './FieldsBlock';
import { FactsBlock } from './FactsBlock';
import { ManagerLabel } from './ManagerLabel';
var size = 24;
export var ProductSummary = function (_React$Component) {
  _inherits(ProductSummary, _React$Component);
  var _super = _createSuper(ProductSummary);
  function ProductSummary() {
    var _this;
    _classCallCheck(this, ProductSummary);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      riskPillOpen: false
    });
    _defineProperty(_assertThisInitialized(_this), "getTableCells", function (fields) {
      var _this$props = _this.props,
        product = _this$props.product,
        theme = _this$props.theme,
        productsSubscriptions = _this$props.productsSubscriptions,
        user = _this$props.user;
      var actions = _objectSpread(_objectSpread({}, _this.props.actions), {}, {
        onUserRiskAction: _this.handleUserRiskAction
      });
      return getTableCells({
        fields: fields,
        product: product,
        theme: theme,
        actions: actions,
        productsSubscriptions: productsSubscriptions,
        user: user
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleUserRiskAction", function () {
      if (!_this.state.riskPillOpen) {
        _this.setState({
          riskPillOpen: true
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleUserRiskClose", function () {
      _this.setState({
        riskPillOpen: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleSubscriptionAction", function () {
      var id = _this.props.product.entity.id;
      _this.props.actions.onProductSubscription('product', 'subscribe', id, !_this.props.productsSubscriptions.includes(id), _this.props.product);
    });
    return _this;
  }
  _createClass(ProductSummary, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        product = _this$props2.product,
        productsSubscriptions = _this$props2.productsSubscriptions,
        _this$props2$withBuyB = _this$props2.withBuyButton,
        withBuyButton = _this$props2$withBuyB === void 0 ? true : _this$props2$withBuyB,
        _this$props2$withHead = _this$props2.withHeaderActions,
        withHeaderActions = _this$props2$withHead === void 0 ? true : _this$props2$withHead,
        _this$props2$withShar = _this$props2.withShareAction,
        withShareAction = _this$props2$withShar === void 0 ? withHeaderActions : _this$props2$withShar,
        _this$props2$withMana = _this$props2.withManager,
        withManager = _this$props2$withMana === void 0 ? false : _this$props2$withMana,
        theme = _this$props2.theme,
        _this$props2$twoColum = _this$props2.twoColumns,
        twoColumns = _this$props2$twoColum === void 0 ? false : _this$props2$twoColum,
        _this$props2$fixedSiz = _this$props2.fixedSize,
        fixedSize = _this$props2$fixedSiz === void 0 ? false : _this$props2$fixedSiz,
        _this$props2$isOnCaro = _this$props2.isOnCarousel,
        isOnCarousel = _this$props2$isOnCaro === void 0 ? false : _this$props2$isOnCaro,
        _this$props2$isOnArti = _this$props2.isOnArticle,
        isOnArticle = _this$props2$isOnArti === void 0 ? false : _this$props2$isOnArti;
      var id = this.props.product.entity.id;
      var _theme$partner$consum = theme.partner.consumer,
        consumer = _theme$partner$consum === void 0 ? 'finect' : _theme$partner$consum;
      var productFields = fieldsByProductType.find(function (element) {
        return element.productType === product.subtype;
      });
      var _productFields$headli = productFields.headlineFields,
        headlineFieldsDefinition = _productFields$headli === void 0 ? [] : _productFields$headli,
        _productFields$mainFi = productFields.mainFields,
        mainFieldsDefinition = _productFields$mainFi === void 0 ? [] : _productFields$mainFi,
        _productFields$mainFi2 = productFields.mainFieldsNew,
        mainFieldsNewDefinition = _productFields$mainFi2 === void 0 ? [] : _productFields$mainFi2,
        _productFields$header = productFields.headerFields,
        headerFields = _productFields$header === void 0 ? [] : _productFields$header;
      var headlineFields = headlineFieldsDefinition.map(function (field) {
        if (isObject(field) && field.id === 'name') {
          return _objectSpread(_objectSpread({}, field), {}, {
            withlink: isOnArticle ? true : field.withlink || false
          });
        }
        if (isObject(field) && field.id === 'classes') {
          return _objectSpread(_objectSpread({}, field), {}, {
            withModal: isOnArticle ? false : field.withModal || true,
            withPaddingTop: !isOnArticle && !isOnCarousel
          });
        }
        return field;
      });
      var mainFields = mainFieldsDefinition.map(function (field) {
        if (isObject(field) && field.id === 'classes') {
          return _objectSpread(_objectSpread({}, field), {}, {
            withModal: isOnArticle ? false : field.withModal || true,
            withPaddingTop: !isOnArticle && !isOnCarousel
          });
        }
        return field;
      });
      var mainFieldsNew = mainFieldsNewDefinition.map(function (field) {
        if (isObject(field) && field.id === 'classes') {
          return _objectSpread(_objectSpread({}, field), {}, {
            withModal: isOnArticle ? false : field.withModal || true,
            withPaddingTop: !isOnArticle && !isOnCarousel
          });
        }
        return field;
      });
      var headerRows = this.getTableCells(headerFields);
      var mainRows = this.getTableCells(mainFields);
      var mainRowsNew = this.getTableCells(mainFieldsNew);
      var headlineRows = this.getTableCells(headlineFields);
      var facts = meta(product, 'facts') || {
        parsedValue: []
      };
      var pill = "".concat(getSuperPartnerBaseURL(), "/pills/es_ES/").concat(consumer, "/default/conoce-tu-perfil-inversor");
      var iicProducts = getProductTypesByCategory('iic').map(function (_ref) {
        var idProduct = _ref.id;
        return idProduct;
      });
      var url = getProductPath(product);
      var nameLinkProps = iicProducts.includes(product.subtype) && !(product.isin || product.entity.isin) ? null : {
        href: url,
        target: '_blank'
      };
      var productName = getProductDisplayName(product);
      var manager = getProductManager(product);
      var _product$entity = product.entity,
        name = _product$entity.name,
        score = _product$entity.score;
      var _theme$partner$produc = theme.partner.productsFeatures,
        productsFeatures = _theme$partner$produc === void 0 ? ['rating'] : _theme$partner$produc;
      return React.createElement(Fragment, null, React.createElement(Inner, {
        fixedSize: fixedSize
      }, React.createElement("div", null, React.createElement(HeaderBlockTop, null, !withHeaderActions ? null : React.createElement(HeaderActions, null, !withShareAction ? null : React.createElement(Share, {
        title: productName,
        url: url,
        via: "Finect",
        positionX: "bottom"
      }, React.createElement(Share2, {
        size: "".concat(size, "px")
      })), productsFeatures.includes('rating') ? React.createElement(HeartAction, {
        onClick: this.handleSubscriptionAction,
        active: productsSubscriptions.includes(id),
        title: "A\xF1adir a favoritos"
      }, React.createElement(Heart, {
        size: "".concat(size, "px")
      })) : null), !withManager ? null : React.createElement(ManagerLabel, {
        manager: manager,
        lazyLoad: isOnCarousel
      }), isOnArticle || isOnCarousel ? React.createElement(FeaturedFieldBlock, {
        small: true
      }, React.createElement(Flex, null, React.createElement(AppLink, _extends({
        black: isOnCarousel
      }, nameLinkProps), name))) : React.createElement(FeaturedFieldBlock, null, headlineRows[0] ? headlineRows[0].component : null), React.createElement(FeaturedFieldBlock2, null, headlineRows[1] ? headlineRows[1].component : null), React.createElement(FeaturedFieldBlock2, null, headlineRows[2] ? headlineRows[2].component : null), isOnArticle && React.createElement(Rating, {
        size: "small",
        value: score || 0,
        isSelectable: false,
        starSize: "16px",
        type: "infoStar"
      }))), React.createElement("div", null, React.createElement(FieldsBlock, {
        showEmpty: false,
        rows: headerRows,
        twoColumns: twoColumns,
        isOnCarousel: isOnCarousel,
        withBar: Boolean(mainRowsNew.length)
      }), React.createElement(MainBlock, null, facts.parsedValue && facts.parsedValue.length > 0 ? React.createElement(FactsBlock, {
        facts: facts.parsedValue
      }) : null, React.createElement(FieldsBlock, {
        font: isOnArticle || isOnCarousel || !mainRowsNew.length ? -1 : 0,
        ellipsisLines: isOnArticle || !mainRowsNew.length ? null : 1,
        showEmpty: false,
        rows: (mainRowsNew.length ? mainRowsNew : mainRows).filter(function (item) {
          return withBuyButton || item.meta.field.id !== 'buyButton';
        })
      })))), React.createElement(PillModal, {
        pill: pill,
        open: this.state.riskPillOpen,
        onClose: this.handleUserRiskClose,
        replaceParentOn: {
          event: 'results',
          target: '_self'
        }
      }));
    }
  }]);
  return ProductSummary;
}(React.Component);
export default withTheme(ProductSummary);